import { KeyboardEvent } from "react";

export function isEnterPressed(e: KeyboardEvent<HTMLDivElement>) {
  if (e.key === "Enter") {
    return true;
  } else {
    return false;
  }
}
